"use strict";

var AjaxObservable_1 = require('./AjaxObservable');

exports.ajax = AjaxObservable_1.AjaxObservable.create;